import { faArchive, faCircle, faFolderOpen, faLayerGroup, faUser, faUserSlash } from '@fortawesome/pro-solid-svg-icons';
import { FEATURES } from '~/provides/features';

export function canUseMessageHub() {
    const onCorporate = !Spark.state.currentOrgUnit?.id && !Spark.state.currentGroup?.group_id;
    const isOrgUnit = !!Spark.state.currentOrgUnit?.id;

    if (isOrgUnit) {
        return FEATURES?.message_hub_ou;
    }

    return onCorporate || !Spark.state.currentTeam.groups_use_corporate_numbers;
}

export function getStatusForInbox(inbox) {
    if (!inbox || inbox === 'all') {
        return undefined;
    }

    if (inbox === 'me') {
        return 'open';
    }

    if (inbox === 'unassigned') {
        return 'unassigned';
    }

    if (inbox === 'open') {
        return 'open';
    }

    if (inbox === 'closed') {
        return 'closed';
    }

    return undefined;
}

export const getInboxIcon = (key) => {
    const inboxIcons = {
        me: faUser,
        unassigned: faUserSlash,
        open: faFolderOpen,
        closed: faArchive,
        all: faLayerGroup,
    };

    return inboxIcons[key] || faCircle;
};
